export default "/assets/gong-logo-acd42d1f68ac8967d68c484b42ec679f11cbccef7c2ee64e541c84dc2379f905.svg";